import React, { Component } from 'react';
import './nav.css'
import capitalLogo from '../../assets/images/33Capitallogo.png'

class Contact extends Component {
  state={
    display:'none'
  }
  componentDidMount() {
    if(window.location.pathname === '/') {
      window.addEventListener('scroll', this.handleScroll);
    }
    else {
      this.setState({ display: 'block'})
    }
  }

  componentWillUnmount() {
    //if(window.location.pathname == '/')
      window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    var doc = document.documentElement;
    var top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
    if(top > 100)
      this.setState({ display: 'block'})
    else
      this.setState({ display: 'none'})
  };
  render(props) {
    const { display } = this.state
    return (
        <nav className="navbar navbar-default navbar-main navbar-fixed-top" style={{ display: display}}>
          <div className="container">
            <div className="row">
              <div className="col col-sm-12">
                <div className="navbar-header visible-xs visible-sm">
                  <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#mynavbar">
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bars"></span>
                    <span className="icon-bars"></span>
                    <span className="icon-bars"></span>
                  </button>
                  <a className="navbar-brand" href="/">
                    <img className="halfsize navbar-brand-mobile" src={capitalLogo} alt=""/>
                  </a>
                </div>
                <div className="collapse navbar-collapse" id="mynavbar">
                  <a className="hidden-xs hidden-sm navbar-brand-desktop" href="/">
                    <img className="img-responsive halfsize" src={capitalLogo} alt=""/>
                  </a>
                  <div className="left-cell">
                    <ul id="menu-main-menu" className="nav navbar-nav">
                      <li id="menu-item-1173" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-94 current_page_item menu-item-1173">
                        <a href="/">HOME</a>
                      </li>
                      <li id="menu-item-1388" className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-1388">
                        <a href="/#about">ABOUT US</a>
                      </li>
                      <li id="menu-item-1389" className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-1389">
                        <a href="/#team">OUR PEOPLE</a>
                      </li>
                      <li id="menu-item-1391" className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-1391">
                        <a href="/#investments">INVESTMENTS</a>
                      </li>
                      <li id="menu-item-1393" className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-1393">
                        <a href="/#contact">CONTACT US</a>
                      </li>
                      <li id="menu-item-1376" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1376">
                        <a href="/news">NEWS</a>
                      </li>
                    </ul>
                  </div>
                  <div className="right-cell">
                    <form className="navbar-form navbar-right searchform" id="menusearchform" method="get" action="https://33-capital.com/" role="search">
                      <ul>
                        <li>
                          <div className="popup_form hide-me-first">
                            <input type="text" className="form-control" id="sm" name="s" placeholder="Search" />
                          </div>
                          <a className="search_btn"><i className="icon-search"></i></a>
                        </li>
                      </ul>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js